// Vuex records module actions
import { API } from '@/config';

import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getList({ state, commit }) {
    try {
      const params = {
        page: state.list.page,
      };
      const { records, total } = (await API.get('campaigns/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
};
